import React, { useEffect, useState } from 'react';
import { listTypes, urls } from '../../constants.js';

const DocumentLink = (props) => {
    const [url, setUrl] = useState('');
    const [urlText, setUrlText] = useState('');

    useEffect(() => {
        switch (props.type) {
            case listTypes.Documents:
                setUrl(`${urls.documentsPage}/${props.doc.id}`);

                const docKind = props.doc.fields.find(f => f.name == 'DocKind')?.value;
                const startDate = props.doc.fields.find(f => f.name == 'ClaimDateStart')?.value;
                const endDate = props.doc.fields.find(f => f.name == 'ClaimDateEnd')?.value;
                setUrlText(`${docKind} з ${startDate} по ${endDate}`);
                break;
        }
    }, [])


    const onClick = () => {
        if (props.type === listTypes.Documents) {
            navigate();
        }
    }

    return <div className='doc-link' key={props.doc.id}>
        <a href={url}>{urlText}</a>
    </div>
}

export default DocumentLink;